import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoaderService } from '../services/loader.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {

  constructor(private readonly loaderService: LoaderService) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Don't show loader for notification-related API calls only
    const isNotificationCall = request.url.includes('/EmployeeStatus/getnotifications') ||
      request.url.includes('/getTrainingNotificationsMessageByEmployeeNumber');

    // Don't show loader for silent background operations
    const isSilentCall = request.headers.has('X-Silent-Request');

    if (!isNotificationCall && !isSilentCall) {
      this.loaderService.showLoader();
      return next.handle(request).pipe(
        finalize(() => this.loaderService.hideLoader())
      );
    }

    // For notification and silent calls, proceed without showing loader
    return next.handle(request);
  }
}